import React from 'react'

class AutoAddInstrumentPlanDiv extends React.Component {
    state = {
        instrumentID: this.props.instrumentID || 0,
        inspectionPlanID: this.props.inspectionPlanID || 0,
    }

    componentDidMount = () => {
        this.doGetAutoAddInstrumentPlan()
    }

    doGetAutoAddInstrumentPlan = () => {
        const { instrumentID, inspectionPlanID } = this.state
        Tyan.doPostEvent('GetAutoAddInstrumentPlan', {
            data: { instrumentID, inspectionPlanID },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        Tyan.doPostEvent('SaveAutoAddInstrumentPlan', {
            data: Tyan.utility.getChangedFieldsets(this, '基本信息', false),
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('操作成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handleClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }


    canSave = () => {
        return Tyan.utility.hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        const { optionsParas: { items自动计划 } } = this.state
        return [
            {
                _checkgrid: '请选择自动创建以下计量\\期间核查\\维护保养计划', name: '自动计划', rowNumbers: false, minRows: 5, maxRows: 10,
                itemsValues: items自动计划,
                selectableField: 'selectable',
                columns: [
                    { _text: '计划日期', minWidth: 200 },
                    { _text: '设备参数', minWidth: 400 },
                    { _text: '计划类型', minWidth: 150 },
                    { _text: '有效日期', minWidth: 250, },
                    { _text: '周期（月）', name: '周期', minWidth: 150, },
                ],
            }
        ]
    }

    render = () => {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={1500}
            controls={
                [
                    { _button: '确定', disabled: !this.canSave(), handler: this.handlerSave },
                    { _button: '取消', handler: this.handleClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default AutoAddInstrumentPlanDiv
